import React from "react";
import { Button, SxProps, Theme } from "@mui/material";

import { AppTheme } from "Utils/theme";

interface IProps {
  label: string;
  disabled?: boolean;
  variant: "outlined" | "contained" | "text";
  buttonColor?: string;
  labelColor?: string;
  onBtnClick: (e: any) => void;
  uppercase: boolean;
  buttonSize: "xs" | "sm" | "md" | "lg";
  buttonHeight: "sm" | "md";
  buttonContainerStyle?: SxProps<Theme>;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

export const EllipticalButton = (props: IProps) => {
  const {
    label,
    disabled,
    variant,
    buttonColor,
    labelColor,
    onBtnClick,
    uppercase,
    buttonSize,
    buttonHeight,
    buttonContainerStyle,
    startIcon,
    endIcon,
  } = props;

  const matchButtonSize = (size: "xs" | "sm" | "md" | "lg") => {
    return {
      xs: "15%",
      sm: "25%",
      md: "50%",
      lg: "100%",
    }[size];
  };

  const matchButtonHeight = (size: "sm" | "md") => {
    return {
      sm: "35px",
      md: "43px",
    }[size];
  };

  return (
    <Button
      variant={variant}
      disabled={disabled}
      onClick={onBtnClick}
      startIcon={startIcon}
      endIcon={endIcon}
      size="medium"
      sx={{
        height: matchButtonHeight(buttonHeight),
        backgroundColor: buttonColor,
        // margin: `10px 0px`,
        textTransform: uppercase ? "uppercase" : "none",
        // width: ,//matchButtonSize(buttonSize),
        alignSelf: "flex-start",
        color: labelColor,
        borderRadius: AppTheme.roundness2,
        // padding: matchButtonHeight(buttonHeight),
        fontSize: AppTheme.fontSize.caption,
        fontWeight: "700",
        ...buttonContainerStyle,
      }}
    >
      {label}
    </Button>
  );
};
